import React from 'react';
import { 
  ThemeProvider, 
  Container, 
  Card, 
  CardContent, 
  Box, 
  Typography, 
  Button, 
  Icon, 
  Alert 
} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import theme from '../utils/theme';
import { API_URL } from '../utils/api';

function Login({ error }) {
  const [authMode, setAuthMode] = React.useState('production');

  React.useEffect(() => {
    fetch(`${API_URL}/info`)
      .then(res => res.json())
      .then(data => {
        if (data.authMode) setAuthMode(data.authMode);
      })
      .catch(err => console.error("Failed to fetch info", err));
  }, []);

  const handleLogin = async () => {
    try {
      const response = await fetch(`${API_URL}/auth/google/url`);
      const data = await response.json();
      if (data.url) {
        window.location.href = data.url;
      }
    } catch (err) {
      console.error("Failed to get Google auth URL", err);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs" sx={{ display: 'flex', alignItems: 'center', height: '100vh' }}>
        <Card sx={{ p: 2, width: '100%' }}>
          <CardContent>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <img src="/v3-2.png" alt="Logo" style={{ height: '50px' }} />
              <Typography component="h1" variant="h5" sx={{ mt: 1 }}>
                SKIS Schedule Login
              </Typography>
            </Box>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{decodeURIComponent(error)}</Alert>}
            <Button
              fullWidth
              variant="contained"
              onClick={handleLogin}
              sx={{ mt: 2, mb: 2, display: 'flex', alignItems: 'center' }}
            >
              <LoginIcon sx={{ mr: 1 }} /> 
              Sign In with Google
            </Button>
            
            {authMode === 'dev' && (
              <Button
                fullWidth
                variant="outlined"
                color="secondary"
                onClick={() => window.location.href = `${API_URL}/auth/dev`}
                sx={{ mt: 1, mb: 2 }}
              >
                Developer Login
              </Button>
            )}
          </CardContent>
        </Card>
      </Container>
    </ThemeProvider>
  );
}

export default Login;
